import React, { FC } from 'react';
import * as S from 'components/Forms/Forms.style';
import {
  Control,
  FieldErrors,
  useFieldArray,
  UseFormRegister,
} from 'react-hook-form';
import deleteIcon from 'assets/delete.png';
import addIcon from 'assets/add.png';
import { Button, ButtonVariant } from 'components/Button/Button';
import { TextInput } from 'components/Forms/TextInput/TextInput';
import { IFormFields, IPlayer } from 'pages/Game/Game';
import { createDefaultScores } from 'utils/game';

interface IProps {
  register: UseFormRegister<IFormFields>;
  control: Control<IFormFields>;
  errors: FieldErrors;
  rounds: number;
}

export const AddPlayerForm: FC<IProps> = ({
  register,
  control,
  errors,
  rounds,
}) => {
  const { fields, append, remove } = useFieldArray<IFormFields>({
    control,
    name: 'players',
  });

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>, index: number) => {
    if (!e.target.value.trim()) {
      e.target.value = `Player ${index + 1}`;
    }
  };

  const handleFocus = (
    e: React.FocusEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.target.value === `Player ${index + 1}`) {
      e.target.value = '';
    }
  };

  const handleAddPlayer = () => {
    append({
      player: `Player ${fields.length + 1}`,
      scores: createDefaultScores(rounds),
      totalPoints: 0,
      isActive: true,
    });
  };

  return (
    <>
      <S.MultiColumnContainer>
        {fields.map((item, index) => {
          const playerErrors = errors.players as
            | FieldErrors<IPlayer>[]
            | undefined;

          return (
            <S.MultiColumnWrapper key={item.id}>
              <TextInput
                label={`Player / Hráč ${index + 1}`}
                name={`players.${index}.player`}
                register={register}
                rules={{
                  required: 'Player name is required',
                  minLength: {
                    value: 2,
                    message: 'Player name must be at least 2 characters long',
                  },
                }}
                placeholder={`Player ${index + 1}`}
                defaultValue={item.player || ''}
                onBlur={(e) => handleBlur(e, index)}
                onFocus={(e) => handleFocus(e, index)}
                errorMessage={playerErrors?.[index]?.player?.message || ''}
              />
              {index !== 0 && (
                <Button
                  variant={ButtonVariant.DELETE}
                  onClick={() => remove(index)}
                >
                  <img src={deleteIcon} alt="Delete" />
                </Button>
              )}
            </S.MultiColumnWrapper>
          );
        })}
      </S.MultiColumnContainer>
      <div>
        <Button
          type="button"
          variant={ButtonVariant.ADD}
          onClick={handleAddPlayer}
        >
          Add player / Přidat hráče
          <img src={addIcon} alt="Add player" />
        </Button>
      </div>
    </>
  );
};
